import { createReducer, on } from '@ngrx/store';
import {
  loadAccountList,
  loadAccountListSuccess,
  loadAccountListFailure,
  clearAccountList,
} from './account.actions';

export interface AccountState {
  data: any[] | null;
  loading: boolean;
  error: any;
}

export const initialState: AccountState = {
  data: null,
  loading: false,
  error: null,
};

export const accountReducer = createReducer(
  initialState,
  on(loadAccountList, (state) => ({ ...state, loading: true, error: null })),
  on(loadAccountListSuccess, (state, { data }) => ({ ...state, loading: false, data })),
  on(loadAccountListFailure, (state, { error }) => ({ ...state, loading: false, error })),
  on(clearAccountList, (state) => ({ ...state, data: null }))
);
